import { BLACK_700 } from '../colors';
var cardTitleConfig = {
  color: BLACK_700,
  actionTypes: 'none',
  showActionCtaWithCheveron: true,
  actionRotationAngle: '180deg',
  actionHealthType: 'success',
  showInfoIcon: false,
  showOnMountInfoIconTooltip: false,
  isActionIconPressable: false,
  showBulletSeperator: false
};
export default {
  light: cardTitleConfig,
  dark: cardTitleConfig,
  white: cardTitleConfig
};